module.exports = __webpack_public_path__ + "static/img/008.a94ee71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/008.png
// module id = ulkj
// module chunks = 0